import { render, staticRenderFns } from "./ApprovedLogframe.vue?vue&type=template&id=9e485b04&"
import script from "./ApprovedLogframe.vue?vue&type=script&lang=js&"
export * from "./ApprovedLogframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports